import { PageTemplate, HeaderTemplate, ButtonLink } from "../styles";
import SizeChart from "../components/SizeChart";

const SizeGuide = () => {
  return (
    <>
      <HeaderTemplate className="narrow">
        <div className="header flex-header">
          <div className="title">
            <h1>Size Guide</h1>
          </div>
          <div className="breadcrumb">
            <ButtonLink to="/designs" className="small clear">
              Browse Designs
            </ButtonLink>
          </div>
        </div>
      </HeaderTemplate>
      <PageTemplate className="narrow">
        <div className="content-page">
          <SizeChart />
        </div>
      </PageTemplate>
    </>
  );
};

export default SizeGuide;
